import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWebcamIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	stroke: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_13639_1004)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 16.6182C15.7279 16.6182 18.75 13.5961 18.75 9.86816C18.75 6.14024 15.7279 3.11816 12 3.11816C8.27208 3.11816 5.25 6.14024 5.25 9.86816C5.25 13.5961 8.27208 16.6182 12 16.6182Z",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 12.8682C13.6569 12.8682 15 11.525 15 9.86816C15 8.21131 13.6569 6.86816 12 6.86816C10.3431 6.86816 9 8.21131 9 9.86816C9 11.525 10.3431 12.8682 12 12.8682Z",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 16.6182V19.6182",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3 19.6182H21",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_13639_1004",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white",
			transform: "translate(0 0.118164)"
		})
	}) })]
});
export default SvgWebcamIcon;
